import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { eventTypeSelector, useGetEventTypeQuery } from 'root-api'


export const useEventType = () => {
  const { params } = useRouteMatch()
  const { isLoading } = useGetEventTypeQuery(
    {
      profileSlug: params.profileSlug,
      slug: params.eventTypeSlug
    },
    { skip: !params.profileSlug || !params.eventTypeSlug }
  )

  const eventType = useSelector(eventTypeSelector)

  if (isLoading) return undefined
  if (!eventType) return null
  return eventType
}
